import { ua } from '../../../../util/user-agent';

export class Controller {

    /** @ngInject */
    constructor() {
    }

    $onInit() {
        this.showIEText = !(ua.isChrome() || ua.isOpera() || ua.isFirefox() || ua.isSafari());
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/public/extension-alert/extension-alert.controller.js